import { render, staticRenderFns } from "./DeviceServices.vue?vue&type=template&id=2f1382b8&"
import script from "./DeviceServices.vue?vue&type=script&lang=js&"
export * from "./DeviceServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports